// extracted by mini-css-extract-plugin
export default {"myModal":"modal_myModal__DRX1s","myModalContent":"modal_myModalContent__rtr5s","active":"modal_active__jIh-f"};